/**
 * useRevealTask — hook that navigates to a task's location and opens it.
 */

import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { resolveTaskRoute } from "./revealAndOpenTask"

/**
 * Returns a function that navigates to the view containing a task
 * and opens its detail panel.
 *
 * If the task doesn't exist, does nothing.
 */
export function useRevealTask() {
  const navigate = useNavigate()

  return useCallback(
    async (taskId: string) => {
      const route = await resolveTaskRoute(taskId)
      if (route) {
        navigate(route)
      }
    },
    [navigate],
  )
}
